import { useMemo } from 'react';
import ContentLoader from 'react-content-loader';
import ExamFeedback from '../../../../../core/components/templates/Exam/Feedback';
import Container from '../../../../../core/components/atoms/Container';
import { usePracticeEnemFeedbackHook } from '../../../hooks/Enem/feedback';
import { Breadcrumbs } from '../../../../../core/components/organism/Breadcrumbs';
import NoContent from '../../../../../core/components/templates/NoContent';
import { SimuladoPrintItem } from '../../../../../core/components/organism/PrintComponent/SimuladoPrintModal';
import { useParams } from 'react-router-dom';

const PracticeEnemFeedback = () => {
  const {
    data,
    day,
    exercises,
    isError,
    correctAnswersPercentage,
    correctAnswersTotal,
    wrongAnswersTotal,
    breadCrumbsItems,
    timeSpent,
    isLoading,
    remakeExam,
  } = usePracticeEnemFeedbackHook();

  const { slug } = useParams();

  /**
   * Itens do modal de impressão. No formato de dois dias o aluno pode levar as
   * duas provas e o gabarito, marcando cada um de forma independente. Item sem
   * PDF cadastrado aparece desabilitado, com o motivo.
   */
  const printableFiles = useMemo<SimuladoPrintItem[]>(() => {
    if (!data) return [];

    if (!data.hasSecondDay) {
      return [
        {
          id: 'prova',
          label: 'Prova',
          description: 'Caderno de questões no modelo Enem, sem gabarito.',
          url: data.provaPdfUrl ?? data.provaPdfUrlDay1,
          filename: 'prova.pdf',
        },
        {
          id: 'gabarito',
          label: 'Gabarito',
          description: 'Prova com as respostas corretas assinaladas.',
          url: data.gabaritoPdfUrl ?? data.pdfUrl,
          filename: 'gabarito.pdf',
        },
      ];
    }

    return [
      {
        id: 'prova-dia-1',
        label: 'Prova — Dia 1',
        description: 'Linguagens, Códigos e Ciências Humanas.',
        url: data.provaPdfUrlDay1,
        filename: 'prova-dia-1.pdf',
      },
      {
        id: 'prova-dia-2',
        label: 'Prova — Dia 2',
        description: 'Ciências da Natureza e Matemática.',
        url: data.provaPdfUrlDay2,
        filename: 'prova-dia-2.pdf',
      },
      {
        id: 'gabarito',
        label: day ? `Gabarito — Dia ${day}` : 'Gabarito',
        description: 'Prova com as respostas corretas assinaladas.',
        url:
          day === 2
            ? data.gabaritoPdfUrlDay2 ?? data.pdfUrlSecondDay
            : data.gabaritoPdfUrlDay1 ?? data.pdfUrl,
        filename: day ? `gabarito-dia-${day}.pdf` : 'gabarito.pdf',
      },
    ];
  }, [data, day]);

  if (isLoading) {
    return (
      <Container>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 30'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100' height='15' />
        </ContentLoader>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 80'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100%' height='70' />
        </ContentLoader>
        {Array.from({ length: 5 }, (_, index) => (
          <ContentLoader
            key={`${index}_loader`}
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 24'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100%' height='20' />
          </ContentLoader>
        ))}
      </Container>
    );
  }

  if(isError) {
    const url = `/simulados/enem`;

    return <NoContent url={url} />
  }

  return (
    <>
      <Container className='pb-0 xl:pb-0'>
        <Breadcrumbs items={breadCrumbsItems} />
      </Container>
      <ExamFeedback
        exercises={exercises}
        onRemake={() => remakeExam()}
        correctAnswersPercentage={correctAnswersPercentage}
        correctAnswersTotal={correctAnswersTotal}
        wrongAnswersTotal={wrongAnswersTotal}
        type='enem'
        day={day}
        printableFiles={printableFiles}
        timeSpent={timeSpent}
        isMegaSimulation={slug?.includes('mega')}
      />
    </>
  );
};
export default PracticeEnemFeedback;
